import { QuizRep } from '../../types/quiz/quiz.def';

export interface QuizState {
  reponses: QuizRep[];
  currentQuestion: number;
}
export const initialState = { reponses: [], currentQuestion: 1 };

const quizReducer = (state: QuizState = initialState, action) => {
  switch (action.type) {
    case 'NEXT_QUESTION': {
      const newState = {
        ...state,
        reponses: [...state.reponses, action.payload],
        currentQuestion: state.currentQuestion + 1
      };
      return newState || state;
    }
    case 'EXIT_GAME':
      return initialState;
    default:
      return initialState;
  }
};

export default quizReducer;
